module.exports = __webpack_public_path__ + "img/chart.3f42d503.jpg";